import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { Appear } from "@components/motion/Appear"
import { HubspotForm } from "@components/atoms/HubspotForm"

export const meta: BlockMeta = {
  title: "Hubspot Form",
  tags: ["#page"],
}

export default defineBlock("content/hubspot-form", (props) => {
  return (
    <div className={cn("w-full my-blockSpace", props.negativeSpacing && " -mt-blockSpace pt-5 md:pt-4")}>
      <div className="w-full content-sized grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="w-full grid grid-rows-1 gap-4">
          <Appear className="w-full h-full flex flex-col justify-between gap-5 md:gap-4 rounded-md bg-slate600 text-slate50 p-5">
            <Appear slide delay={50}>
              <EditableText
                store="title"
                as="p"
                placeholder="Title"
                className="type-sans-base-semibold md:type-sans-xl-semibold text-pretty"
              />
            </Appear>
            <Appear slide delay={150}>
              <EditableText
                store="description"
                className="type-serif-lg-regular md:type-serif-2-xl-regular text-pretty"
                defaultValue="Description text"
                placeholder="Description text"
              />
            </Appear>
          </Appear>
        </div>
        <div className="w-full rounded-md flex flex-col justify-between p-5 bg-slate300">
          {props.hubspotFormSelection ? (
            <HubspotForm key={props.hubspotFormSelection} formId={props.hubspotFormSelection} />
          ) : props.hubspotFormId ? (
            <HubspotForm key={props.hubspotFormId} formId={props.hubspotFormId} />
          ) : (
            env.admin && (
              <div className="w-full h-full flex items-center justify-center text-slate950 type-sans-base-regular">
                Hubspot Form not configured. Please set the Form ID to display the form.
              </div>
            )
          )}
        </div>
      </div>
    </div>
  )
})
